import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import {
  TweenMax,
  TimelineMax,
  Power2
} from 'gsap';
import '../../lib/gsap/DrawSVGPlugin';

class HeroIntro extends Component {

  state = {
    svgMounted: false
  }

  svgFadeIn = () => {
    TweenMax.fromTo(
      this.svg,
      2.25,
      {
        opacity: '0'
      },
      {
        opacity: '0.5',
        ease: Power2.easeIn,
        onComplete: this.svgDraw
      }
    );

    this.animateSvg();
  }

  animateSvg = () => {
    TweenMax.to(
      '.heroIntro__line',
      2.25,
      {
        width: '50%',
        ease: Power2.easeIn
      }
    );
  }

  svgDraw = () => {
    const tl = new TimelineMax();

    tl.to(
      '.marquee--draw__path',
      1,
      {
        drawSVG: '100%',
        onComplete: this.animateSvgOut
      }
    );
  }

  animateSvgOut = () => {
    TweenMax.set(
      '.heroIntro__line.left',
      {
        right: 'auto',
        left: '0'
      }
    );
    TweenMax.set(
      '.heroIntro__line.right',
      {
        left: 'auto',
        right: '0'
      }
    );
    TweenMax.to(
      '.heroIntro__line',
      0.3,
      {
        width: '0'
      }
    );
    TweenMax.to(
      '.heroIntro__bgBlock',
      0.8,
      {
        height: '0',
        opacity: '0.7'
      }
    )

    this.undrawSvg();
  }

  undrawSvg = () => {
    const tl = new TimelineMax();

    tl.to(
      '.marquee--draw__path',
      1,
      {
        drawSVG: '0',
        onComplete: this.onTransitionEnd
      }
    );
  }

  onTransitionEnd = () => {
    document.body.classList.remove('home-transition');
    TweenMax.set(
      '.heroIntro',
      {
        'z-index': '5'
      }
    );
    this.props.onTransitionEnd();
  }

  componentWillMount() {
    document.body.classList.add('home-transition');
  }

  componentDidMount() {
    TweenMax.set(
      '.marquee--draw__path',
      {
        drawSVG: '50% 50%'
      }
    );

    if (sessionStorage.getItem('cachedHit') !== 'true') {
      this.setState({
        svgMounted: true
      });
      sessionStorage.setItem('cachedHit', 'true');
    } else {
      this.unsetAnimation();
    }
  }

  unsetAnimation = () => {
    this.onTransitionEnd();
    TweenMax.set(
      '.heroIntro__bgBlock',
      {
        height: '0',
        opacity: '0.7'
      }
    );
    TweenMax.set(
      this.svg,
      {
        opacity: '0.5'
      }
    );
  }

  render() {
    return (
      <Transition
        className="heroIntro"
        component="div"
        in={this.state.svgMounted}
        timeout={0}
        onEnter={this.svgFadeIn}
      >
        <div key="hero-intro-animation">
          <svg
            className="marquee marquee--initial"
            viewBox="0 0 1345 352"
            xmlns="http://www.w3.org/2000/svg"
            ref={s => this.svg = s}
          >
            <path d="M65.246 114.867c14.462 37.02 28.83 74.078 43.222 111.122.257-.063.382-.09.636-.153 13.719-43.479 27.541-86.926 41.795-130.23 27.017-7.557 40.607-11.897 67.882-20.606-3.282 37.336-2.463 75.123-2.095 112.382.369 36.905.205 74.387 4.314 111.288-23.495 8.49-35.22 12.727-58.619 20.352 1.629-25.105 1.48-38.52 1.292-55.1-.417-37.506-.629-56.532-1.049-93.867l-.639.19c-14.024 44.153-27.847 88.367-41.844 132.53-12.68 3.427-19.011 5.004-31.653 7.747-15.477-38.898-30.338-78.036-45.012-117.244l-.625.07c.31 32.853.611 65.705.913 98.558.16 16.89.282 30.575 2.414 55.1-17.91 2.268-26.85 2.945-44.698 2.994 3.372-38.516 2.625-77.498 2.372-115.955-.247-37.746.02-76.04-3.852-113.803 25.868.014 38.93-1.277 65.246-5.375M342.875 177.032c-3.62-13.475-14.8-47.643-19.08-60.59l-.65.19c-5.083 15.716-16.46 56.85-19.904 72.604 15.839-5.148 23.765-7.636 39.634-12.204M357.738 33c10.63 46.324 29.038 91.101 44.911 135.716 15.339 43.145 22.473 57.311 27.351 67.556-25.858 3.873-38.76 6.843-64.52 13.801-1.323-7.906-6.874-24.178-12.752-39.452-24.104 6.802-36.141 10.755-60.162 18.915-5.982 19.467-9.083 34.238-11.232 47.373C262.375 283.62 252.904 287.122 234 294c26.75-73.051 45.602-149.014 66.502-223.854a6574.524 6574.524 0 0 0-6.294-19.169c25.375-7.792 38.092-11.56 63.53-17.977M503.691 100.147c2.264.422 7.464.589 11.324.318 24.116-1.694 37.223-14.673 37.206-31.093-.021-16.42-13.142-28.071-37.296-26.075-3.86.319-9.063 1.324-11.327 2.118.034 21.892.055 32.84.093 54.732m14.094-91.125c31.753-2.082 49.7-1.386 64.856 5.895 20.076 9.645 30.51 25.67 30.524 48.172.014 21.896-10.355 45.4-40.796 59.341 6.623 13.669 9.933 20.517 16.552 34.24 16.226 33.405 25.625 52.64 33.079 64.315-27.592.665-41.38 1.227-68.945 2.824-2.6-7.756-4.223-12.531-9.742-25.87a26137.726 26137.726 0 0 0-25.328-61.816c-5.694.43-8.54.651-14.232 1.12l.063 37.705c.027 15.81.052 28.58 2.028 52.14-24.562 1.992-36.835 3.05-61.345 5.912 3.558-36.157 3.06-72.795 2.98-108.906-.083-35.872.298-72.296-3.479-108.192 29.479-3.334 44.24-4.665 73.785-6.88M725.082 35.24c-21.568-.554-31.713 27.56-31.723 77.712-.01 50.145 10.106 78.3 31.64 78.855 21.533.554 31.666-27.079 31.708-77.224.042-50.152-10.053-78.789-31.625-79.343M804.785 274c-31.908-1.45-63.843-18.153-76.22-47.239-1.304.268-2.608.234-3.584.21-58.226-1.559-94.998-61.002-94.981-113.702.017-51.964 37.285-115.733 95.103-113.196C784.253 2.67 819.916 62.03 820 118.155c.052 37.119-14.59 76.401-47.726 96.51 8.791 11.74 24.104 16.553 38.76 18.156-2.497 16.467-3.748 24.702-6.249 41.179M900.348 15.86c-2 23.542-2.03 36.354-2.065 52.201l-.215 93.567c-.056 24.383 7.352 38.431 30.991 42.721 25.58 4.641 32.134-8.837 32.255-34.286.177-36.552.268-54.866.441-91.288.077-15.89.143-28.725-1.711-52.834C978.789 30 988.196 32.371 1007 37.464c-2.17 23.146-2.27 36.034-2.399 51.992l-.756 93.984c-.23 28.698-7.39 44.934-22.772 52.424-15.846 7.715-35.647 8.952-60.866 4.783-22.31-3.69-42.353-11.12-56.252-23.68-18.078-16.342-22.303-33.989-22.244-69.65.06-33.895.09-50.836.146-84.73.028-15.851.052-28.652-1.857-52.587 24.16 1.987 36.22 3.085 60.348 5.86M1176.085 88.434c-.327 15.207-.495 22.917-.815 38.454-24.964-11.184-48.36-18.726-67.926-25.017-5.74-1.846-8.614-2.771-14.367-4.618-.414 5.463-.93 16.834-1.103 28.06-.181 11.228-1.277 27.033.188 28.99 7.09 9.431 44.764 14.87 58.33 17.624-.306 15.475-.459 23.25-.769 38.787-13.472-6.04-55.463-22.992-58.118-21.226-1.069.71-.936 18.02-1.124 29.958-.192 11.942-.06 23.963.167 30.337 36.45 13.865 72.68 24.154 86.452 26.654l-.832 39.563c-48.86-16.747-97.352-34.496-146.168-51.39 4.163-36.338 4.04-73.261 4.444-109.607.404-36.795 1.25-74.128-2.08-111.003 47.98 14.58 95.733 29.871 143.72 44.434M1339.815 119.32c-.118 15.168-.18 22.919-.298 38.614-23.115-4.05-45.002-6.744-63.48-9.86a480.387 480.387 0 0 1-13.599-2.472c-.42 5.609-.954 17.25-1.183 28.749-.215 11.499-1.304 28.055.063 29.672 6.21 7.334 42.65 6.886 55.434 6.234-.19 15.834-.284 23.81-.479 39.744-12.832-2.648-52.128-12.411-55.639-9.735-1.266.965-.981 18.687-1.217 30.987-.233 12.304-.153 24.622.038 31.12 35.424 8.507 70.338 8.389 83.545 6.476-.1 16.21-.153 24.272-.257 40.151-49.318-.52-95.624-12.256-142.743-25.531 4.524-37.461 4.787-75.54 5.575-113.042.784-37.596 2.054-75.713-.78-113.427 43.989 12.214 89.248 21.363 135.02 22.32" id="marquee" fill="none" />
          </svg>

          <svg
            className="marquee marquee--draw"
            viewBox="0 0 1345 352"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g strokeWidth="1" fill="none" fillRule="evenodd">
              <path d="M65.2455683,114.8671 C79.7075371,151.886798 94.0757323,188.944693 108.468239,225.988699 C108.725248,225.926195 108.85028,225.898415 109.103816,225.835911 C122.822542,182.357472 136.645461,138.910285 150.899045,95.6054675 C177.916253,88.0494349 191.506475,83.7088831 218.780692,75 C215.498617,112.33569 216.318268,150.122798 216.686416,187.382095 C217.054564,224.287202 216.891328,261.768735 221,298.670371 C197.50451,307.16049 185.779341,311.396868 162.381098,319.02235 C164.009979,293.916598 163.860636,280.502557 163.673089,263.921649 C163.256318,226.415809 163.044459,207.390302 162.624214,170.054612 C162.370678,170.131006 162.242174,170.169203 161.985165,170.245596 C147.960806,214.397689 134.137887,258.612286 120.141313,302.774796 C107.461042,306.202096 101.129589,307.778585 88.487522,310.521813 C73.0114094,271.623524 58.1500346,232.485637 43.4762069,193.2783 L42.8510498,193.347749 C43.1601553,226.200518 43.4623146,259.053286 43.7644738,291.906055 C43.9242362,308.79601 44.0457946,322.480902 46.1782751,347.006755 C28.2675226,349.27426 19.3277753,349.951386 1.4795386,350 C4.85191413,311.48368 4.10519864,272.502052 3.85166269,234.044763 C3.60507292,196.299324 3.87250126,158.00524 0,120.24244 C25.8676138,120.256329 38.9299252,118.964581 65.2455683,114.8671" className="marquee--draw__path" />
              <path d="M342.875387,177.032343 C339.254309,163.557318 328.075139,129.388631 323.79442,116.44163 C323.534036,116.518055 323.40558,116.556267 323.145195,116.632691 C318.062492,132.348342 306.685431,173.482078 303.241414,189.235942 C319.079727,184.087711 327.005828,181.600442 342.875387,177.032343 M357.738128,33 C368.368754,79.3236527 386.776193,124.101447 402.649225,168.71597 C417.987601,211.86106 425.122133,226.027378 430,236.271731 C404.142095,240.145063 391.240918,243.115196 365.480223,250.073297 C364.157471,242.166837 358.606076,225.895372 352.728332,210.620899 C328.623683,217.422677 316.586981,221.375907 292.565654,229.535956 C286.583757,249.003354 283.483447,263.774121 281.334408,276.908709 C262.374954,283.620167 252.903906,287.121797 234,294 C260.750155,220.948624 279.601984,144.986171 300.50217,70.1457682 C297.985121,62.4512132 296.728332,58.6160941 294.207812,50.9771206 C319.583137,43.1852981 332.30031,39.416182 357.738128,33" className="marquee--draw__path" />
              <path d="M503.691069,100.146597 C505.955189,100.569399 511.155049,100.735747 515.015131,100.465431 C539.131126,98.7707575 552.238097,85.7921219 552.220787,69.3721552 C552.200016,52.9521885 539.079197,41.300874 514.925121,43.297054 C511.065038,43.6158883 505.861716,44.6209095 503.597596,45.4145296 C503.632216,67.3066634 503.652987,78.2544631 503.691069,100.146597 M517.784697,9.02236615 C549.53777,6.9395464 567.484557,7.63613004 582.641007,14.9173352 C602.716897,24.5620729 613.151237,40.5869624 613.165085,63.08904 C613.178933,84.9846394 602.81037,108.488273 572.369379,122.430342 C578.992104,136.09863 582.301735,142.946637 588.920997,156.670374 C605.147192,190.075199 614.546406,209.309225 622,220.984799 C594.4082,221.650192 580.619224,222.211617 553.055119,223.809255 C550.455189,216.053264 548.831531,211.27768 543.313171,197.938623 C533.186946,173.149256 528.122102,160.787495 517.985491,136.122889 C512.290571,136.552623 509.444842,136.77442 503.753384,137.242275 C503.777618,152.324524 503.791466,159.865648 503.815699,174.947897 C503.843395,190.75792 503.867629,203.52862 505.844406,227.087703 C481.281819,229.080417 469.00918,230.137422 444.498522,233 C448.057414,196.843497 447.558892,160.205276 447.479267,124.093826 C447.39618,88.2215007 447.776995,51.7981469 444,15.9015628 C473.478567,12.567665 488.240353,11.2368783 517.784697,9.02236615" className="marquee--draw__path" />
              <path d="M725.081882,35.2403278 C703.513577,34.6862155 693.369325,62.7995736 693.358864,112.951964 C693.348402,163.097385 703.464757,191.252563 724.99819,191.806675 C746.531623,192.360788 756.665413,164.728357 756.70726,114.582936 C756.749106,64.4305457 746.653675,35.7944401 725.081882,35.2403278 M804.785226,274 C772.877386,272.550247 740.941648,255.846723 728.565591,226.761055 C727.26138,227.029399 725.957168,226.994549 724.980754,226.970154 C666.755048,225.412367 629.98257,165.969011 630.000006,113.269098 C630.017442,61.3045159 667.285102,-2.46370353 725.102806,0.0733641087 C784.252618,2.66967646 819.916168,62.0293924 819.99986,118.155044 C820.052168,155.273598 805.409434,194.556327 772.274101,214.664679 C781.065321,226.405587 796.377597,231.218348 811.03428,232.821441 C808.537448,249.287985 807.285545,257.523 804.785226,274" className="marquee--draw__path" />
              <path d="M900.348272,15.8603185 C898.348812,39.4023331 898.317571,52.2137467 898.282858,68.0612708 C898.196076,105.488107 898.15442,124.201524 898.067638,161.62836 C898.012098,186.011037 905.419817,200.059127 929.059261,204.349283 C954.639153,208.990294 961.192937,195.511909 961.314432,170.062772 C961.491467,133.511337 961.581721,115.197407 961.755285,78.7745028 C961.831653,62.885293 961.897608,50.0495627 960.043942,25.941317 C978.788875,29.9987278 988.196055,32.3713404 1007,37.4639468 C1004.83045,60.609947 1004.72978,73.4977844 1004.60134,89.4564705 C1004.29934,126.890254 1004.1466,145.791257 1003.8446,183.440417 C1003.6155,212.137567 996.454239,228.374157 981.07298,235.863693 C965.226569,243.579027 945.426365,244.815703 920.207487,240.64713 C897.897545,236.957943 877.854352,229.527463 863.955331,216.966163 C845.876884,200.625358 841.652331,182.9784 841.711343,147.31626 C841.770355,113.42229 841.801596,96.4805156 841.857137,62.5865453 C841.884907,46.7355474 841.909206,33.9345552 840,10 C864.160136,11.9870197 876.219377,13.0847438 900.348272,15.8603185" className="marquee--draw__path" />
              <path d="M1176.08467,88.4344213 C1175.75751,103.641161 1175.59045,111.350593 1175.27026,126.887687 C1150.30563,115.704317 1126.91065,108.161802 1107.34406,101.871157 C1101.60494,100.024649 1098.73017,99.0996561 1092.97713,97.2531482 C1092.56297,102.716169 1092.04787,114.087319 1091.87385,125.312418 C1091.69288,136.540994 1090.59656,152.345849 1092.06179,154.303635 C1099.15129,163.734387 1136.8262,169.173065 1150.39264,171.927179 C1150.08637,187.40168 1149.93323,195.177182 1149.62348,210.714277 C1136.15101,204.674005 1094.16045,187.721602 1091.50494,189.488129 C1090.43647,190.197522 1090.56872,207.508099 1090.38078,219.446068 C1090.18936,231.387515 1090.32161,243.408942 1090.54784,249.783045 C1126.99766,263.647503 1163.22821,273.937176 1177,276.437438 C1176.66589,292.357049 1176.49883,300.289035 1176.16819,316 C1127.30741,299.252765 1078.81554,281.504034 1030,264.610747 C1034.16251,228.27175 1034.0407,191.348547 1034.44442,155.002595 C1034.84814,118.208057 1035.69387,80.874519 1032.36316,44 C1080.34342,58.5808052 1128.09745,73.8710032 1176.08467,88.4344213" className="marquee--draw__path" />
              <path d="M1339.81528,119.320942 C1339.69733,134.488493 1339.63489,142.238868 1339.51693,157.933985 C1316.40172,153.88352 1294.5146,151.190152 1276.0377,148.073342 C1270.61883,147.157042 1267.89898,146.660712 1262.43848,145.602107 C1262.0187,151.210977 1261.48445,162.852159 1261.25548,174.351036 C1261.04039,185.849914 1259.95107,202.405798 1261.31793,204.023208 C1267.52778,211.357083 1303.96815,210.909345 1316.75211,210.256828 C1316.56131,226.090779 1316.46764,234.066758 1316.27336,250.001364 C1303.44083,247.353116 1264.14532,237.589656 1260.6345,240.26567 C1259.36824,241.230563 1259.65272,258.952648 1259.41681,271.253288 C1259.18438,283.5574 1259.26417,295.875394 1259.45497,302.372798 C1294.87887,310.879815 1329.79279,310.761807 1343,308.849377 C1342.89939,325.058178 1342.84736,333.120928 1342.74328,349 C1293.42528,348.479375 1247.11853,336.74448 1200,323.468535 C1204.52382,286.007809 1204.78748,247.929275 1205.57499,210.426899 C1206.35902,172.830811 1207.62875,134.714097 1204.79442,97 C1248.78375,109.21387 1294.04279,118.362992 1339.81528,119.320942" className="marquee--draw__path" />
            </g>
          </svg>

          <div className="heroIntro__backgroundBlock">
            <div className="heroIntro__bgBlock upper"></div>
            <div className="heroIntro__line left"></div>
            <div className="heroIntro__line right"></div>
            <div className="heroIntro__bgBlock lower"></div>
          </div>
        </div>
      </Transition>
    );
  }
}

export default HeroIntro;
